<template>
  <Modal
    :modal="modal"
    title="Selecione a Data"
    @close="$emit('close')"
    @save="$emit('save', dateSelected)"
    :titleIcons="[]"
  >
    <v-date-picker
      v-model="dateSelected"
      scrollable
    >
    </v-date-picker>
  </Modal>
</template>

<script>
import Modal from '@/components/shared/Modal';

export default {
  name: 'ModalEmissao',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    editEmissao: {
      type: String,
      default: ''
    }
  },
  components: {
    Modal
  },
  data: () => ({
    dateSelected: null,
  }),
  watch: {
    modal(value) {
      if (!value) {
        this.dateSelected = null;
      }
    },
    editEmissao(value) {
      if (value) {
        this.dateSelected = value;
      }
    }
  },
}
</script>

<style>

</style>